module.exports = __webpack_public_path__ + "images/album_1080.b0c4ed0405680ef66e746b279b5456aa.png";